/**
 * Roles que pueden operar en "modo global" (ver/operar todas las sucursales
 * de su cliente combinadas). Mismo listado que
 * app/utils/sucursal_scope.py::ROLES_MODO_GLOBAL en el backend.
 */
export const ROLES_MODO_GLOBAL = ['admin', 'supervisor', 'superadmin', 'franquiciado'];

export function puedeModoGlobal(user) {
  return ROLES_MODO_GLOBAL.includes(user?.role);
}
